// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/hankerBackground.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginPage_container {
  height: 100vh;
  /* width: 100vw; */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  /* background-size: cover; */
  background-repeat: no-repeat;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /* background-color: #051422; */
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/LoginPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,yDAA0D;EAC1D,4BAA4B;EAC5B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;AACjC","sourcesContent":[".LoginPage_container {\n  height: 100vh;\n  /* width: 100vw; */\n  background-image: url('../../assets/hankerBackground.svg');\n  /* background-size: cover; */\n  background-repeat: no-repeat;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  /* background-color: #051422; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
